<template>
    <configurable-sankey-v2 />
</template>

<script>
    import {ConfigurableSankeyV2} from "@modules/JourneyBuilder/Components/Charts";

    export default {
        name: "JourneyBuilderOverviewSankey",
        components: {
            ConfigurableSankeyV2
        }
    }
</script>
